export default "public/close-popup.svg";